export function canWriteAgentTools(role: string | undefined) {
  return role === 'admin' || role === 'super_admin'
}
